/*eslint-disable */
// import $ from 'jquery'
// var jQuery = $
// import Chart from 'chart.js'
// import VueChart from 'vue-chart-js'
import { Line, mixins } from 'vue-chartjs'

// const { reactiveProp } = mixins
export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options', 'cssClasses', 'height', 'width', 'styles'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
/*eslint-disable */
import Vue from 'vue'
// Vue.use(ChartJSCross)
var ComponentClass = Vue.extend(Line)
var instance = new ComponentClass()
instance.$mount()
// const checkp = document.querySelector('body').appendChild(instance.$el)
Vue.prototype.$line = instance
var pingVM = new Vue(instance)



// WEBPACK FOOTER //
// ./src/components/views/chartline.js